import { imageUrl } from '@helpers/image';
import CtaLink from '@stories/Components/CtaLink/CtaLink';
import SocialLinks from '@stories/Components/Misc/SocialLinks/SocialLinks';
import * as React from 'react';
import S from './Footer.styles';
import LinkList from './LinkList/LinkList';
const Footer = ({ anchorId, footerButtons, footerLinks, legalCopy, legalLinks, socialLinks, footerLogo, footerLogoLink, logo, }) => {
    const [openList, setOpenList] = React.useState('');
    const handleListClick = (id) => {
        if (id === openList) {
            setOpenList('');
        }
        else {
            setOpenList(id);
        }
    };
    return (React.createElement(S.Container, { id: anchorId },
        React.createElement(S.Inner, null,
            React.createElement(S.MainWrapper, null,
                React.createElement("div", null,
                    React.createElement(S.LogoLink, { href: "/", "aria-label": "Homepage" },
                        React.createElement(S.Logo, { alt: logo.altText, loading: "lazy", src: imageUrl(logo, { width: 308 }) })),
                    React.createElement(SocialLinks, { items: socialLinks })),
                React.createElement(S.LinksWrapper, null,
                    footerLinks.map((links, i) => (React.createElement(LinkList, { key: `footer-links-${i}`, active: openList === `footer-links-${i}`, onClick: () => handleListClick(`footer-links-${i}`), ...links }))),
                    React.createElement(S.ButtonsWrapper, null, footerButtons.map((button, i) => (React.createElement(CtaLink, { key: `footer-button-${i}`, href: button.url, target: button.target, size: "small" }, button.text))))),
                footerLogo ? (React.createElement(S.FooterLogoWrapper, { "data-desktop-only": true, ...(footerLogoLink
                        ? {
                            as: 'a',
                            href: footerLogoLink.url,
                            title: footerLogoLink.text,
                            target: footerLogoLink.target,
                        }
                        : {}) },
                    React.createElement(S.FooterLogo, { alt: footerLogo.altText, src: imageUrl(footerLogo, { width: 328, height: 262 }) }))) : null),
            React.createElement(S.LegalWrapper, null,
                React.createElement(LinkList, { active: openList === `legal-links`, onClick: () => handleListClick(`legal-links`), ...legalLinks }),
                footerLogo ? (React.createElement(S.FooterLogoWrapper, { "data-mobile-only": true, ...(footerLogoLink
                        ? {
                            as: 'a',
                            href: footerLogoLink.url,
                            title: footerLogoLink.text,
                            target: footerLogoLink.target,
                        }
                        : {}) },
                    React.createElement(S.FooterLogo, { alt: footerLogo.altText, src: imageUrl(footerLogo, { width: 218, height: 174 }) }))) : null,
                React.createElement(S.LegalCopy, null, legalCopy)))));
};
export default Footer;
